@@ -0,0 +1,70 @@
<template>
    <div>
{{errorMsg}}
    </div>
</template>

<script>
  /* eslint-disable */
  // import { Store, dispatch, mapState } from 'vuex'
  import axios from 'axios'
  import api from "@/utils/backend-api"
  export default {
  name: 'SuperLogin',
  props:['id','su_token'],
  created () {
    this.loadUserData()
  },
  data () {
      return {
        errorMsg:''
      }
    },
  methods:{
    loadUserData(){

      // let config={
      //   headers:{
      //     'Authorization': 'Bearer '+this.su_
      //   }
      // }
      // axios.get('https://backend.tittam.com/public/api/admin/profile',config)
      // .then(res=>{


      // })
      let config={
        headers:{
          'Authorization': 'Bearer '+this.su_token
        }
      }
      try{
        axios.post('https://backend.tittam.com/public/api/driver/getAdminToken',{admin_id:this.id},config)
        .then(res=>{
          if(res.status==201){
            // router.push(')
            const token = res.data.token
            const userinfo = res.data.user
            const adminPackageInfo=res.data.responce
            const user={...userinfo,...adminPackageInfo}
  
            var expireDate=new Date()
            expireDate.setMinutes(expireDate.getMinutes()+res.data.expires_in_minutes)
            expireDate=new Date(expireDate)
            const pusherToken=res.data.unique_token
            Store.dispatch('updateUser', { user, token ,pusherToken,expireDate})
            Store.state.SidebarStatus=true;
            Store.dispatch('Login');
            // debugger
          }
        })
      }catch(ex){
        this.errorMsg="Failed to login"
      }
    }
  },
  computed:{

  }
}
</script>


// WEBPACK FOOTER //
// src/components/SuperLogin.vue